import { Sheet } from "react-modal-sheet";
import { useState, useRef, useEffect } from "react";
import { useNavigate, createSearchParams } from 'react-router-dom';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import "../pages/paymentPage.css";
import CloseIcon from "@mui/icons-material/Close";

import checkCircle from "../assets/images/checkCircle.png";
import DataServices from "./DataServices";
import { useGlobalState } from "../globalStyle";


export default function ModalBottomSheet({
  open,
  cardInfo,
  subPlans,
  handleClose,
  usersInfo,
  formattype
}) {
  const [cardData, setCardData] = useState([]);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountedPrice, setDiscountedPrice] = useState(0);
  const navigate = useNavigate();
  const leadSquaredBody = useGlobalState("leadSquaredDataVal")[0];
  const paymentBaseUrl = useGlobalState("PAYMENTBASEURL")[0];

  useEffect(() => {
    if (cardInfo.length > 0) {
      const updatedCardData = cardInfo.map(item => {
        if (item.code.includes("PROTIPS")) {
          return { ...item, code: item.code.replace("PROTIPS", "STOXCALLS") };
        }
        return item;
      });
      setCardData(updatedCardData);
    }
  }, [cardInfo, subPlans, usersInfo, discountPercentage, discountedPrice]);


  let isPaymentGateway = "";

  const submit = async () => {
    try {
      const data = await DataServices.productData();
      if (data) {
        const paymentConfig = await DataServices.paymentMenthod(paymentBaseUrl);
        const isOneTimePurchase = data && data.products.some(product => {
          return product.child.some(child => {
            product.child.map(val => {
              if (val.code === cardInfo[0].code) {
                isPaymentGateway = val.paymentGateway;
              }
            })
            return child.code === cardData[0]['code'] && !cardData[0]['recurring'];
          });
        });

        let currentPaymentGatewayType;
        let paymentGateway;
        if (isOneTimePurchase) {
          currentPaymentGatewayType = "onetime";
          paymentGateway = paymentConfig && paymentConfig.data.currentPaymentGateway.onetime;
        } else {
          currentPaymentGatewayType = "subscription";
          paymentGateway = paymentConfig && paymentConfig.data.currentPaymentGateway.subscription;
        }
        if (currentPaymentGatewayType && paymentGateway) {
          cardData.map((obj) => {
            return navigate({
              pathname: isPaymentGateway ? isPaymentGateway.toLowerCase() : paymentGateway.toLowerCase(),
              search: `?${createSearchParams({
                clientCode: usersInfo && usersInfo.clientCode ? usersInfo.clientCode : '',
                mobile: usersInfo && usersInfo.mobile ? usersInfo.mobile : '',
                mailId: usersInfo && usersInfo.client_email ? usersInfo.client_email : '',
                planCode: obj.code || '',
                paymentMethod: currentPaymentGatewayType,
                formattype: formattype,
                ...leadSquaredBody
              })}`,
            });
          });
        }

      }
    } catch (err) {
      console.log(err);
    }
  }

  const listItemStyle = {
    listStyle: "none",
    position: "relative",
    paddingLeft: "30px",
  };

  const bulletStyle = {
    position: "absolute",
    left: "0",
    top: "0",
    fontSize: "18px",
    fontWeight: "bold",
  };

  return (
    <div>
      <Sheet
        style={{
          width: '97%',
          position: 'fixed',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          margin: '0 auto', minWidth: "250px", maxWidth: "1250px",

        }}
        isOpen={open}
        onClose={handleClose}
        snapPoints={[500, 0]}

      >
        <Sheet.Container style={{ boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37' }}>
          <Sheet.Content>
            <div style={{ display: 'flex', position: 'absolute', right: 0, top: 0 }}>
              <IconButton
                style={{
                  marginBottom: '8px',
                }}
                onClick={handleClose}
              >
                <CloseIcon size="small" />
              </IconButton>
            </div>
            {cardData &&
              cardData.map((val, index) => (
                <Grid container p={2} key={index}>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="h6" style={{ fontFamily: 'Montserrat', fontWeight: 700 }} className="title">
                      {val.data.title && val.data.title}
                    </Typography>
                    <p className="subtitle">{val.data.description}</p>
                    <Card sx={{ maxHeight: "100%", maxWidth: "94%", position: 'relative', boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}>
                      <CardContent>
                        {
                          val.price <= val.afterDiscount ? null :
                            <span key={val.code} className="discount-badge-desktop" data-animate="true">
                              Save {Math.floor(val && val.offerPrice ? ((val.price - val.offerPrice) / val.price) * 100 : ((val.price - val.afterDiscount) / val.price) * 100)} %
                            </span>
                        }
                        <div>
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "1", display: "flex", alignItems: "center" }}>
                              <div
                                style={{
                                  fontWeight: 900,
                                  lineHeight: "35px",
                                  fontSize: "35px",
                                  color: "#101828",
                                  fontFamily: "Montserrat",
                                }}
                              >
                                ₹{val.offerPrice ? val.offerPrice && val.offerPrice.toLocaleString() : val.afterDiscount.toLocaleString()}
                              </div>
                            </div>
                            <div style={{ flex: "11", display: "flex", alignItems: "center" }}>
                              <div className="yearly-gst">
                                <div style={{ fontSize: '14px', color: '#727070', marginTop: '10px', fontWeight: 400 }}> + GST</div>
                              </div>
                            </div>
                          </div>

                          <div className="price-wrapper">
                            {
                              val.price <= val.afterDiscount ? null : <div className="price-container">
                                <div className="cut-price">
                                  <span className="strikediag withpadding">₹{val.price && val.price.toLocaleString()}</span>
                                </div>
                              </div>
                            }
                          </div>
                          <div>
                            {
                              val.price <= val.afterDiscount ? null :
                                <span key={val.code} className="discount-badge-mobile" data-animate="true">
                                  Save {Math.floor(val && val.offerPrice ? ((val.price - val.offerPrice) / val.price) * 100 : ((val.price - val.afterDiscount) / val.price) * 100)} %
                                </span>
                            }
                          </div>
                        </div>
                        <div className="border-bottom"></div>

                        <div >
                          <div className="radio-options">
                            <h6 style={{ margin: '10px 0px', fontWeight: 'bold', fontSize: '15px' }}>Benefits</h6>
                            <div>
                              {cardData.map((item, index) => (
                                <ul style={{ padding: '0px' }} key={index}>
                                  {item.benefits.map((benefit, index) => (
                                    <li key={index} style={listItemStyle}>
                                      <span style={bulletStyle}>
                                        <img src={checkCircle} alt="check-circle" />
                                      </span>
                                      {benefit}
                                    </li>
                                  ))}
                                </ul>
                              ))}
                            </div>
                            <div className="subscribe">
                              <Button
                                variant="contained"
                                size="small"
                                onClick={submit}
                                sx={{
                                  height: "38px",
                                  backgroundColor: "#563EEC",
                                  fontWeight: 700,
                                  fontSize: "14px",
                                  textTransform: "none",
                                  ":hover": {
                                    backgroundColor: '#563EEC'
                                  }
                                }}
                              >
                                <span>{cardData && cardData[0].ctaButton}</span>
                              </Button>
                            </div>
                          </div>
                        </div>

                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              ))}
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onClick={handleClose} style={{ backgroundColor: 'transparent' }} />
      </Sheet>
    </div>
  );
}
